"use strict";
/**
 * Component: Data Grid - Ajuntament de Manresa
 * Fitxer: DataGrid.tsx
 * Llenguatge: TypeScrypt
 * Autor: Jordi Riu
 * Versió: 1.2
 * Data: 17/11/2017
 * (c) Ajuntament de Manresa - nov 2017 - Departament de Sistemes d'Informació
 */

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var KeyboardArrowUp_1 = require("@material-ui/icons/KeyboardArrowUp");

var KeyboardArrowDown_1 = require("@material-ui/icons/KeyboardArrowDown");

var core_1 = require("@material-ui/core");

var DataGrid =
/** @class */
function (_super) {
  __extends(DataGrid, _super);

  function DataGrid(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      selectedRows: []
    };
    return _this;
  }

  DataGrid.prototype.renderTemplate = function (row, col, rowInfo) {
    var field = col.field || 0;

    if (col.template) {
      return col.template(row[field], row, col, rowInfo);
    }

    return row[field];
  };

  DataGrid.prototype.renderHeader = function (col) {
    var _this = this;

    var handleHeaderClick = function handleHeaderClick() {
      if (_this.props.onHeaderClick) {
        _this.props.onHeaderClick(col);
      }
    };

    var styleIcoOrder = __assign({
      verticalAlign: 'middle'
    }, this.props.styleHeader, col.styleHeader);

    if (col.sortable) {
      var icoOrder = null;

      if (col.order && col.order > 0) {
        icoOrder = React.createElement(KeyboardArrowUp_1.default, {
          style: styleIcoOrder
        });
      }

      if (col.order && col.order < 0) {
        icoOrder = React.createElement(KeyboardArrowDown_1.default, {
          style: styleIcoOrder
        });
      }

      return React.createElement("span", {
        onClick: handleHeaderClick,
        style: {
          cursor: 'pointer',
          verticalAlign: 'middle'
        }
      }, col.title, " ", icoOrder);
    }

    return React.createElement("span", {
      style: {
        verticalAlign: 'middle'
      }
    }, col.title);
  };

  DataGrid.prototype.renderFooter = function (fields) {
    if (!this.props.footerTemplate) {
      return null;
    }

    return React.createElement(core_1.TableFooter, {
      style: this.props.styleFooter
    }, React.createElement(core_1.TableRow, null, React.createElement(core_1.TableCell, {
      colSpan: fields.length
    }, this.props.footerTemplate)));
  };

  DataGrid.prototype.renderStyleCell = function (row, col, rowInfo) {
    var field = col.field || 0;

    if (col.style && typeof col.style === 'function') {
      return col.style(row[field], row, col, rowInfo);
    }

    return col.style;
  };

  DataGrid.prototype.renderStyleRow = function (row, rowInfo) {
    if (this.props.styleRow && typeof this.props.styleRow === 'function') {
      return this.props.styleRow(row, rowInfo);
    }

    return this.props.styleRow;
  };

  DataGrid.prototype.render = function () {
    var _this = this;

    var children = [];
    var fields = [];

    if (!this.props.dataSource) {
      return null;
    }

    if (this.props.children) {
      if (!(this.props.children instanceof Array)) {
        children = [this.props.children];
      } else {
        children = this.props.children;
      }

      fields = children.map(function (dataFieldGrid) {
        return __assign({}, dataFieldGrid.props);
      }).filter(function (f) {
        return f.visible;
      });
    }

    if (!fields.length && this.props.dataSource && this.props.dataSource.length) {
      fields = Object.keys(this.props.dataSource[0]).map(function (col) {
        return {
          field: col
        };
      });
    }

    if (!fields.length) {
      return null;
    }

    fields.forEach(function (field) {
      field.title = field.title || field.field || '';
    });
    var selectable = this.props.selectable || this.props.multiSelectable;

    var onRowSelection = function onRowSelection(selRows) {
      _this.setState({
        selectedRows: selRows
      });

      if (_this.props.onRowSelection) {
        _this.props.onRowSelection(selRows);
      }
    }; // const onRowHover = this.props.onRowHover || ((hoverRow) => { this.setState({hoverRow}); });
    // const onRowHoverExit = this.props.onRowHoverExit || (() => { this.setState({hoverRow: -1}); });


    var selectedRows = this.props.selectedRows || this.state.selectedRows;
    var numSelected = selectedRows.length;
    var numRows = this.props.dataSource.length;

    var handleSelectAllClick = function handleSelectAllClick(event) {
      if (event.target.checked) {
        var newSelecteds = _this.props.dataSource.map(function (row, rowIndex) {
          return rowIndex;
        });

        onRowSelection(newSelecteds);
        return;
      }

      onRowSelection([]);
    };

    var handleSelectRowClick = function handleSelectRowClick(event, rowIndex) {
      if (!_this.props.selectOnClickRow) {
        selectRow(rowIndex);
      }
    };

    var handleClickRow = function handleClickRow(event, rowIndex) {
      if (_this.props.onRowClick) {
        _this.props.onRowClick(rowIndex);
      }

      if (!selectable || !_this.props.selectOnClickRow) {
        return;
      }

      selectRow(rowIndex);
    };

    var selectRow = function selectRow(rowIndex) {
      var newSelected = [];

      if (!_this.props.multiSelectable) {
        newSelected = [rowIndex];
      } else {
        var selectedIndex = selectedRows.indexOf(rowIndex);

        if (selectedIndex === -1) {
          newSelected = selectedRows.concat([rowIndex]);
        } else if (selectedIndex === 0) {
          newSelected = selectedRows.slice(1).slice();
        } else if (selectedIndex === selectedRows.length - 1) {
          newSelected = selectedRows.slice(0, -1).slice();
        } else if (selectedIndex > 0) {
          newSelected = selectedRows.slice(0, selectedIndex).concat(selectedRows.slice(selectedIndex + 1));
        }
      }

      onRowSelection(newSelected);
    };

    return React.createElement(core_1.Table // className={this.props.className}
    // fixedHeader={this.props.fixedHeader}
    // fixedFooter={this.props.fixedFooter}
    // height={this.props.height}
    // onCellClick={this.props.onCellClick}
    // onCellHover={this.props.onCellHover}
    // onCellHoverExit={this.props.onCellHoverExit}
    // onRowHover={onRowHover}
    // onRowHoverExit={onRowHoverExit}
    // onRowSelection={onRowSelection}
    // multiSelectable={this.props.multiSelectable}
    // selectable={this.props.selectable}
    , {
      // className={this.props.className}
      // fixedHeader={this.props.fixedHeader}
      // fixedFooter={this.props.fixedFooter}
      // height={this.props.height}
      // onCellClick={this.props.onCellClick}
      // onCellHover={this.props.onCellHover}
      // onCellHoverExit={this.props.onCellHoverExit}
      // onRowHover={onRowHover}
      // onRowHoverExit={onRowHoverExit}
      // onRowSelection={onRowSelection}
      // multiSelectable={this.props.multiSelectable}
      // selectable={this.props.selectable}
      style: this.props.styleTable,
      padding: this.props.padding,
      size: this.props.size
    }, React.createElement(core_1.TableHead // displaySelectAll={false}
    // adjustForCheckbox={false}
    // style={this.props.styleHeader}
    , null, React.createElement(core_1.TableRow, null, selectable && React.createElement(core_1.TableCell, {
      padding: "checkbox",
      style: __assign({}, this.props.styleHeader)
    }, this.props.multiSelectable && React.createElement(core_1.Checkbox, {
      indeterminate: numSelected > 0 && numSelected < numRows,
      checked: numSelected > 0 && numSelected === numRows,
      onChange: handleSelectAllClick,
      inputProps: {
        'aria-label': 'Select all desserts'
      }
    })), fields.map(function (col, colIndex) {
      return React.createElement(core_1.TableCell, {
        key: colIndex.toString(),
        style: __assign({
          width: col.width
        }, _this.props.styleHeader, col.styleHeader)
      }, _this.renderHeader(col));
    }))), React.createElement(core_1.TableBody // displayRowCheckbox={false}
    // showRowHover={this.props.showRowHover}
    , null, this.props.dataSource.map(function (row, rowIndex) {
      var rowInfo = {
        rowIndex: rowIndex,
        selected: selectedRows.indexOf(rowIndex) >= 0
      };
      return React.createElement(core_1.TableRow, {
        key: rowIndex,
        // selectable={this.props.selectable}
        onClick: function onClick(event) {
          return handleClickRow(event, rowIndex);
        },
        selected: rowInfo.selected,
        "aria-checked": rowInfo.selected,
        hover: _this.props.showRowHover,
        style: _this.renderStyleRow(row, rowInfo)
      }, selectable && React.createElement(core_1.TableCell, {
        padding: "checkbox",
        style: {
          paddingTop: 4,
          paddingBottom: 4
        },
        key: "-1"
      }, React.createElement(core_1.Checkbox, {
        checked: rowInfo.selected,
        onChange: function onChange(event) {
          return handleSelectRowClick(event, rowIndex);
        }
      })), fields.map(function (col, colIndex) {
        return React.createElement(core_1.TableCell, {
          key: colIndex.toString(),
          style: __assign({
            width: col.width
          }, _this.renderStyleCell(row, col, rowInfo))
        }, _this.renderTemplate(row, col, rowInfo));
      }));
    })), this.renderFooter(fields));
  };

  DataGrid.defaultProps = {
    selectOnClickRow: true
  };
  return DataGrid;
}(React.Component);

exports.default = DataGrid;